import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {IAppState} from '../models/IAppState';
import {map, take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  private isAuthorised$: Observable<boolean> = this.store.select((state) => state.AppStateReducer.isAuthorised);

  constructor(
    private store: Store<{AppStateReducer: IAppState}>,
    private router: Router
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isAuthorised$.pipe(
      take(1),
      map((isAuthorised: boolean) => {
        if (!isAuthorised) {
          localStorage.unauthUrl = state.url;
          this.router.navigate(['/login'], {replaceUrl: true});
        } else {
          return true;
        }
      })
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.canActivate(next, state);
  }
}
